import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import { fetchNotifications, markNotificationRead } from "../slices/notificationSlice";


export const useNotifications = () => {
  const dispatch = useAppDispatch();

  const { items, unread, loading, pagination } = useAppSelector(
    (state) => state.notifications
  );

  // Fetch notifications every 60 seconds
  useEffect(() => {
    dispatch(fetchNotifications({}));

    const interval = setInterval(() => {
      if (navigator.onLine) {
        dispatch(fetchNotifications({}));
      }
    }, 60000);

    return () => clearInterval(interval);
  }, [dispatch]);

  const markNotificationAsRead = (id: string) => {
    dispatch(markNotificationRead([id]));
  };

  const markAllAsRead = () => {
    const ids = items.map(n => n.id);
    dispatch(markNotificationRead(ids));
  };

  return {
    notifications: items,
    unread,
    loading,
    pagination,
    markNotificationAsRead,
    markAllAsRead,
  };
};
